module.exports = __webpack_public_path__ + "static/media/ovgu.8e5c4c4d.jpg";